import * as React from 'react'
import heroLg from './images/hero-lg.png'
import heroMd from './images/hero-md.png'
import heroSm from './images/hero-sm.png'
import geometricM from './images/geometric-m.png'
import styles from './styles.module.scss'
import Image from 'next/image'
import clsx from 'clsx'
import { Container } from '@partials/tech-summit/Container'

export function Hero() {
  return (
    <div className={clsx(styles.bgSummit, 'relative')}>
      <Image
        src={geometricM}
        alt=""
        unoptimized
        className="absolute right-0 w-36 md:w-44 lg:w-48 rotate-180 lg:rotate-0 lg:left-0 top-1/2 -translate-y-2/3 lg:-translate-y-1/2"
      />
      <Container className="relative pt-16">
        <p className="text-white font-semibold text-2xl md:text-3xl lg:text-4xl font-body mb-2 md:mb-4 lg:text-center">
          MarketX Ventures
        </p>
        <h1
          className={clsx(
            styles.titleGradient,
            'font-bold font-body sm:text-5xl text-4xl md:text-6xl lg:text-7xl xl:text-8xl lg:text-center max-w-3xl lg:max-w-4xl xl:max-w-5xl lg:mx-auto mb-4',
          )}>
          Technology & Innovation Summit
        </h1>
        <div className="flex flex-col sm:flex-row gap-x-16 pt-4 pb-4 lg:pb-16 gap-y-4 max-w-xl lg:mx-auto">
          <div className="flex flex-col items-start lg:items-center w-full text-white">
            <p className="font-mono text-sm">Location</p>
            <p className="font-medium text-xl">Shack15, San Francisco</p>
          </div>
          <div className="flex flex-col items-start lg:items-center w-full text-white">
            <p className="font-mono text-sm">Date</p>
            <time
              dateTime="September 26th, 2023"
              className="font-medium text-xl">
              September 26th, 2023
            </time>
          </div>
        </div>
        <div className="text-center my-20 md:mt-10 md:mb-32">
          <a
            href="https://ti.to/marketx-ventures/technology-innovation-summit"
            className={clsx(
              'bg-[#96FFE5] px-12 py-6 md:px-16 md:py-8 md:text-3xl rounded-xl font-semibold text-2xl mt-10 md:mt-20 max-w-fit text-[#374151] border-2 border-[#374151] hover:opacity-90 transition-opacity',
            )}>
            Register Now
          </a>
        </div>
        <Image
          src={heroLg}
          alt="Tech summit speakers"
          unoptimized
          className="w-full hidden lg:block"
        />
        <Image
          src={heroMd}
          alt="Tech summit speakers"
          unoptimized
          className="w-full hidden sm:block lg:hidden"
        />
      </Container>
      <Image
        src={heroSm}
        alt="Tech summit speakers"
        unoptimized
        className={'relative w-full block sm:hidden'}
      />
    </div>
  )
}
